export default __webpack_public_path__ + "static/media/cinq.247dfa8a.jpg";